import { RootState } from 'app/store';
import { createSelector } from 'reselect';
import storesAdapter from './stores.adapter';
import { StoreState } from './stores.slice';

export const {
  selectAll: selectStores,
  selectById: selectStoresById,
  selectIds: selectStoresIds,
  selectEntities: selectStoresEntities,
  selectTotal: selectStoresTotal,
} = storesAdapter.getSelectors((state: RootState) => state.storesApp?.stores || {});

const storesSelector = (state: { storesApp: { stores: StoreState } }) => state.storesApp?.stores || {};

export const currentStoreIdSelector = createSelector(storesSelector, store => store.currentStoreId);

export const storesDialogSelector = createSelector(storesSelector, store => store.storeDialog);

export const storesConfirmDialogSelector = createSelector(storesSelector, store => store.confirmDeleteDialog);

export const merchantAndStoresSelector = createSelector(storesSelector, store => store.merchantAndStores);

export const merchantAndStoresFilterSelector = createSelector(storesSelector, store => store.merchantAndStores.filter);

export const merchantAndStoresStatusFilterSelector = createSelector(
  storesSelector,
  store => store.merchantAndStores.statusFilter,
);

export const merchantAndStoresPartnerFilterSelector = createSelector(
  storesSelector,
  store => store.merchantAndStores.partnerFilter,
);

export const merchantAndStoresSortSelector = createSelector(storesSelector, store => store.merchantAndStores.sort);

export const merchantAndStoresPaginationSelector = createSelector(
  storesSelector,
  store => store.merchantAndStores.pagination,
);

export const hasLoadedFilterSortPaginationSelector = createSelector(
  storesSelector,
  store => store.merchantAndStores.hasLoadedFilterSortPagination,
);

export const posMerchantAccountSelector = createSelector(storesSelector, store => store.posMerchantAccount);
export const posMerchantAccountFetchStatusSelector = createSelector(
  storesSelector,
  store => store.posMerchantAccountFetchStatus,
);
export const salesReceptionStatusSelector = createSelector(storesSelector, store => store.salesReceptionStatus);

export const posDialogSelector = createSelector(storesSelector, store => store.posDialog);
export const tagsDialogSelector = createSelector(storesSelector, store => store.tagsDialog);
export const isSettingsLoadingSelector = createSelector(storesSelector, store => store.isSettingsLoading);
